




















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BOOKING_PURPOSES } from '@/constants/booking';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { STATUSES as QUESTIONNAIRE_ANSWER_STATUSES } from '@/constants/questionnaire_answer';
import { mapState } from 'vuex';
import QShareCode from '@/components/QShareCode.vue';
import QDownloadBtn from '@/components/QDownloadBtn.vue';
import _ from 'lodash';

@Component({
  components: {
    QShareCode,
    QDownloadBtn,
  },
  computed: {
    ...mapState('Auth', {
      activeRoleKey: 'activeRoleKey',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
  },
  filters: {
    candidateName: (item, index) => {
      const arr = [item.first_name ?? null, item.last_name ?? null];

      const candidateName = arr.filter(Boolean).join(' ');

      if (candidateName.length == 0) {
        return `Candidate ${index + 1}`;
      }

      return candidateName;
    },
    candidateContact: (item) => {
      const arr = [item.email ?? null, item.mobile ?? null];

      return arr.filter(Boolean).join(', ');
    },
  },
})
export default class BookingReadCandidate extends Vue {
  @Prop() readonly item!: Model;
  @Prop() readonly index!: string;

  booking!: Model;
  activeRoleKey!: string;
  showAttachReportDialog = false;
  attachedReport: File | null = null;

  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  questionnaireAnswerStatuses = QUESTIONNAIRE_ANSWER_STATUSES;
  bookingPurposes = BOOKING_PURPOSES;
  isLoading = false;

  get name() {
    if (!this.item.first_name && !this.item.last_name) {
      return null;
    }
    return (this.item.first_name ?? '') + ' ' + (this.item.last_name ?? '');
  }

  get showResult() {
    if (
      this.item.status &&
      [this.bookingCandidateStatuses.STATUS_COMPLETED.key].includes(
        this.item.status
      )
    ) {
      return true;
    }
    return false;
  }

  get isQuestionnaireCompleted() {
    if (
      this.item.questionnaire_answer?.status &&
      [this.questionnaireAnswerStatuses.STATUS_COMPLETED.key].includes(
        this.item.questionnaire_answer.status
      )
    ) {
      return true;
    }
    return false;
  }

  get showAutoGeneratedResult() {
    if (this.isQuestionnaireCompleted) {
      return true;
    }
    return false;
  }

  get showHCSResult() {
    if (
      this.isQuestionnaireCompleted &&
      !this.item.questionnaire_answer?.is_awaiting_report &&
      this.booking.purpose ==
        this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    ) {
      return true;
    }
    return false;
  }

  get showAttachedResult() {
    if (
      this.isQuestionnaireCompleted &&
      !this.item.questionnaire_answer?.is_awaiting_report &&
      !_.isEmpty(this.item.questionnaire_answer?.report)
    ) {
      return true;
    }
    return false;
  }

  toDownloadReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadReport',
        this.item.questionnaire_answer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  toDownloadAttachedReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadAttachedReport',
        this.item.questionnaire_answer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  toDownloadHCSReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadHCSReport',
        this.item.questionnaire_answer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  get isAdminRole() {
    return this.activeRoleKey === 'rAdmin';
  }

  openAttachReport() {
    this.showAttachReportDialog = true;
  }

  async attachReport() {
    this.isLoading = true;
    this.$store
      .dispatch('QuestionnaireAnswer/attachReport', {
        questionnaireAnswerOid: this.item.questionnaire_answer.object_id,
        report: this.attachedReport,
      })
      .then(async () => {
        const bookingOid = this.$route.params.bookingOid;
        await this.$store.dispatch('Booking/fetch', bookingOid);
        this.isLoading = false;
        this.showAttachReportDialog = false;
      });
  }
}
